<!-- Heading -->
<div #scrollable class="scroll-sidebar scroll-sidebar-auth opacity-block-double">
  <div class="container-fluid pb-6 my-7 my-lg-12">
    <div class="row-col-blocks row align-items-center justify-content-between">
      <div class="col-12 col-lg">
        <div class="text-center">
          <i-feather class="logo-big effect3d" name="telegram" width="133" height="133"></i-feather>
        </div>
        <h1 class="font-bold text-center">{{interfaceService.isTelesellerDomain ? 'TeleSeller' : 'Telegram'}}</h1>
        <ng-template [ngIf]="!sessionPasswordNeeded">
          <ng-template [ngIf]="!arCode.type">
            <p *ngIf="!interfaceService.isTelesellerDomain; else telesellerText" class="text-center mb-6">Пожалуйста,
              введите свой полный номер телефона.</p>
            <ng-template #telesellerText>
              <p *ngIf="!interfaceService.isLeadsDomain" class="text-center mb-6">Пожалуйста, добавьте телеграм аккаунт для рассылки или {{allMessengersService.isAuth ? 'арендуйте готовый' : 'получите первый бесплатно' }}.</p>
              <p *ngIf="interfaceService.isLeadsDomain" class="text-center mb-6">{{allMessengersService.isAuth ? 'Добавьте телеграм аккаунт или арендуйте готовый' : 'Зарегистрируйтесь и получите первый телеграм аккаунт бесплатно' }}.</p>
            </ng-template>
          </ng-template>

          <p *ngIf="arCode.type === 'SentCodeType.APP'" class="text-center mb-6">
            Мы отправили код в <b>приложение</b> Telegram на другом вашем устройстве.<br/>Пожалуйста, введите код ниже.
          </p>
          <p *ngIf="arCode.type === 'SentCodeType.SMS'" class="text-center mb-6">
            Мы отправили код в <b>SMS</b> на номер <b>{{Form.value?.phone}}</b>.<br/>Пожалуйста, введите код ниже.
          </p>
          <p *ngIf="arCode.type === 'SentCodeType.CALL'" class="text-center mb-6">
            Код будет отправлен по телефону <b>{{Form.value?.phone}}</b>. Синтезированный голос сообщит, какой код
            подтверждения нужно ввести.
          </p>
          <p *ngIf="arCode.type === 'SentCodeType.FLASH_CALL'" class="text-center mb-6">
            Код будет отправлен с помощью флэш-телефонного звонка, который будет немедленно закрыт.
          </p>
          <p *ngIf="arCode.type === 'SentCodeType.MISSED_CALL'" class="text-center mb-6">
            Введите последние 6 цыфр пропущенного звонка на номер <b>{{Form.value?.phone}}</b>.
          </p>

        </ng-template>
        <p *ngIf="sessionPasswordNeeded" class="text-center mb-6">У вас включена двухфакторная авторизация.</p>
        <nz-alert *ngIf="!arCode.phone_code_hash && tabindex === 2" nzType="warning" [nzMessage]="descriptionAlert"
                  nzShowIcon></nz-alert>

        <ng-template #descriptionAlert>
          Авторизация по СМС - самый ненадежный способ добавления аккаунтов. Используйте его только в случае, если уверены в наличие отлежки и готовы к рискам.
          <br>
          <!--<small> Данные авторизации будут храниться на нашем сервере, для фоновой рассылки даже после закрытия сайта.</small><br>-->
          <!--<small>Вы можете отозвать авторизацию завершив сессию в настройках оригинального приложения телеграмм, либо
            написав
            нам по кнопке</small>-->
          <!--<a class="text-underline pointer" (click)="senderService.openHelpChatInTelegram()">техподдержка</a>.-->
        </ng-template>
      </div>
      <div class="col-12 col-lg">
        <ng-template #noTokenError>
          <nz-alert nzType="error"
                    [nzMessage]="'Если вы увидели это сообщение, свяжитесь с нами что бы починить авторизацию.'"
                    nzShowIcon></nz-alert>
        </ng-template>
        <nz-tabset *ngIf="telegramService.token; else noTokenError"

                   class="mb-3" (nzSelectedIndexChange)="nzSelectedIndexChange($event)"
                   [tabindex]="tabindex" (click)="nzSelectedIndexChange(tabindex)">
          <nz-tab *ngIf="interfaceService.isTelesellerDomain" [nzTitle]="(authService.mode$ | async)">
            <app-modal-sender-register [telegramService]="telegramService"></app-modal-sender-register>
          </nz-tab>
          <nz-tab *ngIf="interfaceService.isTelesellerDomain && allMessengersService.isAuth" nzTitle="Вход tdata">
            <app-sign-telegram-tdata (resetService)="resetService()" [telegramService]="telegramService"></app-sign-telegram-tdata>
          </nz-tab>
          <nz-tab
            *ngIf="allMessengersService.isAuth"
            nzTitle="Вход по телефону">
            <app-alert-error [error]="lastError"></app-alert-error>
            <!--<div class="text-center mb-2 small text-muted">
              Или по телефону
            </div>-->
            <!-- Form -->
            <form *ngIf="!arCode.phone_code_hash" [formGroup]="Form" (submit)="sendCode()" class="mb-6">

              <div class="form-group">
                <label for="phone" class="sr-only">Номер телефона</label>
                <input
                  type="tel"
                  formControlName="phone"
                  class="form-control form-control-lg justify-content-between"
                  placeholder="+7 (___) ___ __ __"
                  id="phone"
                />
              </div>
              <div *ngIf="false" class="form-group d-flex justify-content-between">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" checked="" id="checkbox-remember"/>
                  <label class="custom-control-label" for="checkbox-remember">Запомнить?</label>
                </div>
                <a>Восстановить пароль</a>
              </div>
              <!-- Submit -->

              <div class="row mb-4">
                <div class="col">
                  <button
                    (mousemove)="allService.effectMouseMove($event)"
                    class="effectMouse effect-white btn btn-lg btn-block btn-primary d-flex align-items-center"
                    type="submit"
                  >
                    Войти
                    <i-feather [style.margin-top.px]="-5" name="log-in"
                               class="ml-auto icon-md align-middle"></i-feather>
                  </button>
                </div>
                <div *ngIf="!allService.environment.production" class="col-auto pl-0">
                  <button
                    (click)="authDemo()"
                    (mousemove)="allService.effectMouseMove($event)"
                    class="effectMouse effect-white btn btn-lg btn-block btn-danger"
                    type="button"
                  >
                    Demo
                  </button>
                </div>
              </div>
            </form>
            <nz-alert *ngIf="interfaceService.isTelesellerDomain && !arCode.phone_code_hash" nzType="success"
                      [nzMessage]="descriptionPhoneAlert" nzShowIcon></nz-alert>

            <ng-template #descriptionPhoneAlert>
              Приобрести номер для регистрации телеграм аккаунта можно на специализированных сайтах, например:<br>
              <a class="text-underline" target="_blank" href="https://sms-man.ru/">sms-man.ru</a>,
              <a class="text-underline" target="_blank"
                 href="https://onlinesim.ru/?ref=289685">onlinesim.ru</a>.<br>
              <!--<small>Планируется добавление встроенных аккаунтов для вашего удобства.</small>-->
            </ng-template>
          </nz-tab>
        </nz-tabset>


        <div class="text-center mb-3">
          <a target="_blank" href="https://t.me/TeleSellerSupportBot">
            <i-feather name="life-buoy" class="mr-2"></i-feather>
            Техническая поддержка
          </a>
        </div>

        <ng-template [ngIf]="!sessionPasswordNeeded" [ngIfElse]="blockPasswordNeeded">
          <nz-alert class="mb-2" *ngIf="(interfaceService.isTelesellerDomain && !interfaceService.isLeadsDomain) && !arCode.phone_code_hash && tabindex === 2"
                    nzType="info"
                    nzMessage="Аккаунт будет использоваться для рассылки, не используйте личный аккаунт, если нет необходимости
            рассылки от своего лица." nzShowIcon></nz-alert>
          <!-- Form -->
          <form
            *ngIf="arCode.phone_code_hash && !sessionPasswordNeeded"
            [formGroup]="FormCode"
            (submit)="checkCode()"
            class="mb-6"
          >
            <div class="form-group">
              <label for="code" class="sr-only">Код</label>
              <input
                #inputCode
                maxlength="5"
                type="text"
                formControlName="code"
                class="form-control form-control-lg"
                placeholder="Введите ваш код"
                id="code"
              />
            </div>
            <div class="form-group d-flex justify-content-between">
              <a class="text-muted pointer text-underline" *ngIf="arCode.type === 'SentCodeType.APP' && arCode.next_type"
                 (click)="resendCode()">
                {{'Получить через ' + arCode.next_type}}
              </a>
              <a class="text-muted pointer text-underline" (click)="backLogin()">Другой номер</a>
            </div>
          </form>
        </ng-template>
        <ng-template #blockPasswordNeeded>
          <alert [type]="'danger'" class="d-block"> Введите пароль</alert>
          <!-- Form -->
          <form [formGroup]="FormPassword" (submit)="checkPassword()" class="mb-6">
            <div class="form-group">
              <label for="password" class="sr-only">Пароль</label>
              <input
                #inputPassword
                type="password"
                formControlName="password"
                class="form-control form-control-lg"
                placeholder="Введите ваш пароль"
                id="password"
              />
            </div>
            <!-- Submit -->
            <button
              [disabled]="isLoading"
              (mousemove)="allService.effectMouseMove($event)"
              class="effectMouse effect-white btn btn-lg btn-block btn-primary d-flex align-items-center"
              type="submit"
            >
              Войти
              <i-feather [style.margin-top.px]="-5" name="log-in" class="ml-auto icon-md align-middle"></i-feather>
            </button>
          </form>
        </ng-template>
      </div>
    </div>
  </div>
</div>
